/**
 * Created by jonas on 2020-10-01.
 */


import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BenjiKIVReelView} from "../view/general/reel/BenjiKIVReelView";
import {SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {gsap} from "gsap";
import {BenjiKIV} from "../BenjiKIV";
import {BenjiKIVSound} from "../sound/BenjiKIVSound";

export interface SimpleReelModelEventData {
    reel:number;
    state:SimpleReelModelState;
}

export interface SimpleReelPaddingData {
    visualPaddingBefore:number;
    paddingBefore:number;
    visibleSymbols:number;
    paddingAfter:number;
    visualPaddingAfter:number;
}

export class BenjiKIVReelModel {
    private readonly _reelId:number;
    private readonly _reelView:BenjiKIVReelView;
    private _state:SimpleReelModelState = SimpleReelModelState.IDLE;

    /**
     * Triggers on: ReelStateChange and each ReelModelState
     */
    public readonly events:APIEventSystem | undefined;

    constructor(id:number, triggerEvents:boolean = true) {
        this._reelId = id;
        this._reelView = new BenjiKIVReelView(id, (state:SimpleReelModelState) => this.setState(state));
        if(triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data:SimpleReelModelEventData) => this.onReelStateChange(data));
        }
    }

    public start():gsap.core.Timeline {
        return this._reelView.start();
    }

    public getReadyToStop():void{
        this.reelView.stop();
    }

    public doStop(reelData:string[]):void {
        this._reelView.doStop(reelData);
    }

    private onReelStateChange(data:SimpleReelModelEventData):void {
        this.events?.trigger(data.state.toString(), data);
    }

    private setState(state:SimpleReelModelState) {
        this._state = state;
        if(this.events) {
            this.events.trigger("ReelStateChange", <SimpleReelModelEventData>{
                reel : this._reelId,
                state : this._state
            });
        }
    }

    get state():SimpleReelModelState {
        return this._state;
    }

    get reelView():BenjiKIVReelView {
        return this._reelView;
    }
}